import { createContext, useMemo } from 'react';
import { PlayerStatuses } from '../stores/AudioPlaybackStore';
import { useMediaPlayback } from '../hooks/useMediaPlayback';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaPlaybackControlsContext = /*#__PURE__*/createContext({
  clipEndTime: null,
  clipStartTime: 0,
  forward: () => undefined,
  onPlayerHeadUpdate: () => undefined,
  pause: () => undefined,
  play: () => undefined,
  preciseDuration: 0,
  reset: () => undefined,
  rewind: () => undefined,
  roundedDuration: 0,
  setClipEndTime: () => undefined,
  setClipStartTime: () => undefined,
  setPlayerHeadLocation: () => undefined,
  playbackRequested: false,
  status: PlayerStatuses.LOADING,
  errorType: null
});
export const MediaPlaybackControlsProvider = ({
  audioDurationInSeconds,
  children,
  clipEndTime,
  clipStartTime,
  containInClipTime = false,
  errorType,
  initialClipEndTime,
  initialClipStartTime,
  mediaRef,
  mediaStateDispatch,
  playbackRequested = false,
  preciseDuration,
  refetchMediaUrl,
  roundedDuration,
  source,
  status
}) => {
  const {
    forward,
    onPlayerHeadUpdate,
    pause,
    play,
    reset,
    rewind,
    setClipEndTime,
    setClipStartTime,
    setPlayerHeadLocation
  } = useMediaPlayback({
    audioDurationInSeconds,
    clipEndTime,
    clipStartTime,
    containInClipTime,
    initialClipEndTime,
    initialClipStartTime,
    mediaRef,
    mediaStateDispatch,
    preciseDuration,
    source,
    status
  });
  const mediaPlaybackControlsValue = useMemo(() => ({
    clipEndTime,
    clipStartTime,
    errorType,
    forward,
    onPlayerHeadUpdate,
    pause,
    play,
    playbackRequested,
    preciseDuration,
    refetchMediaUrl,
    reset,
    rewind,
    roundedDuration,
    setClipEndTime,
    setClipStartTime,
    setPlayerHeadLocation,
    status
  }), [clipEndTime, clipStartTime, errorType, forward, onPlayerHeadUpdate, pause, play, playbackRequested, preciseDuration, refetchMediaUrl, reset, rewind, roundedDuration, setClipEndTime, setClipStartTime, setPlayerHeadLocation, status]);
  return /*#__PURE__*/_jsx(MediaPlaybackControlsContext.Provider, {
    value: mediaPlaybackControlsValue,
    children: children
  });
};